<template>
  <div
    class="container-fluid mycontainer-fluid content"
    v-if="$parent.rerender"
  >
    <HelpFiledStep2
      text="2. Полное наименование проекта"
      :helpText="this.project.UF_HELP.FIELDS.STEP2['UF_NAME']"
    />
    <uf_name></uf_name>

    <HelpFiledStep2
      text="3. Программа финансовой поддержки"
      :helpText="this.project.UF_HELP.FIELDS.STEP2['UF_SUPPORT_PROG_ID']"
    />
    <uf_support_prog_id />

    <div class="content-title content-mb-14">
      4. Оказывал ли региональный фонд развития промышленности методологическую
      и/или информационную помощь при подготовке заявки в Фонд развития
      промышленности
      <span class="icon-warning"></span>
      <VDropdown
        tag="span"
        trigger="click"
        placement="bottom"
        popperClass="custom-popper"
        style="display: inline"
      >
        <a class="icon-help icon-help-l40" />
        <template #popper>
          <div class="custom-popper-content">
            {{ h4tooltip }}
          </div>
        </template>
      </VDropdown>
    </div>
    <uf_is_reg_fond_help></uf_is_reg_fond_help>

    <div class="content-title content-mb-14">
      <span>5</span>. В структуре владения уставным капиталом преобладающее
      участие имеет паевой инвестиционный фонд
    </div>
    <uf_is_prevails_mutual_invest_fund></uf_is_prevails_mutual_invest_fund>

    <div class="content-title content-mb-14">
      6. Требуемый объем финансирования со стороны Фонда, тыс. руб.
    </div>
    <uf_sum_request></uf_sum_request>

    <div class="content-title content-mb-14">7. Сроки займа, мес.</div>
    <uf_month_return></uf_month_return>

    <div class="content-title content-mb-14">8. Отрасль промышленности</div>
    <uf_industry_id></uf_industry_id>

    <div class="content-title content-mb-14">9. Подотрасль промышленности</div>
    <uf_sub_industry_id></uf_sub_industry_id>

    <template v-if="$parent.project.UF_SETTING && $parent.project.UF_SETTING.IS_VIEW_NEW_INFORMATION_PROJECT">
      <div class="content-title content-mb-14">
        10. Информация о продукции проекта
        <VDropdown
          tag="span"
          trigger="click"
          placement="bottom"
          popperClass="custom-popper"
          style="display: inline"
        >
          <a class="icon-help icon-help-l40" />
          <template #popper>
            <div class="custom-popper-content">
              Продукты проекта, перечисленные в резюме должны быть синхронизированы с перечнем из финансовой модели
            </div>
          </template>
        </VDropdown>
      </div>
      <ProjectOkpdProducts></ProjectOkpdProducts>
    </template>
    <template v-else>
      <div class="content-title content-mb-14">
        10. Информация о продукции (в соответствии с перечнем ОКПД)
      </div>
      <okpd></okpd>
    </template>

    <template v-if="this.project.UF_SETTING.IS_VIEW_COMPONENT_PP_719">
      <Uf_component_pp_719></Uf_component_pp_719>
    </template>

    <div class="content-title content-mb-14">
      <span
      >11. Приоритетные комплектующие изделия, применяемые в составе
        "Автокомпонентов"</span
      >
    </div>
    <Uf_prioriti_complect_auto></Uf_prioriti_complect_auto>

    <template v-if="project.UF_SETTING.IS_VIEW_HIGH_TECH == 1">
      <div class="content-title content-title-2line content-mb-14">
        <span>12.</span> Продукция Проекта относится к высокотехнологичной
      </div>
      <HighTechProducts></HighTechProducts>
    </template>

    <div class="content-title content-mb-14">
      <span v-if="project.UF_SETTING.IS_VIEW_HIGH_TECH == 1">13</span
      ><span v-else>12</span>. Планируемые покупатели продукции
      <!--   начало блока подсказки -->
      <span
        v-if="
          project.UF_HELP &&
            project.UF_HELP.FIELDS &&
            project.UF_HELP.FIELDS.STEP2 &&
            project.UF_HELP.FIELDS.STEP2.PLAN_BUYERS_PRODUCTS
        "
        class="h-t-status-info info-holder-container"
      >
        <span class="info-holder-icon" style="z-index: 0"></span>
        <span class="info-holder-content info-holder-content_link">
          <span class="info-holder-content__text">
            {{ project.UF_HELP.FIELDS.STEP2.PLAN_BUYERS_PRODUCTS }}
          </span>
        </span>
      </span>
      <!--   конец блока подсказки   -->
    </div>
    <PlanBuyersProducts></PlanBuyersProducts>

    <div class="content-title content-mb-14">
      <span v-if="project.UF_SETTING.IS_VIEW_HIGH_TECH == 1">14</span
      ><span v-else>13</span>. Аннотация проекта
    </div>
    <uf_annotation></uf_annotation>

    <div class="content-title content-mb-14">
      <span v-if="project.UF_SETTING.IS_VIEW_HIGH_TECH == 1">15</span
      ><span v-else>14</span>. Имеющийся результат по проекту
    </div>
    <uf_available_results></uf_available_results>

    <div class="content-title content-mb-14">
      <span v-if="project.UF_SETTING.IS_VIEW_HIGH_TECH == 1">16</span
      ><span v-else>15</span>. Место реализации проекта
    </div>
    <place></place>

    <div class="content-title content-mb-14">
      <span style="float:left;"
      ><span v-if="project.UF_SETTING.IS_VIEW_HIGH_TECH == 1">17</span
      ><span v-else>16</span>. Продукция производится на спецтерритории</span
      >
      <span style="float: left;margin-top: 12px;margin-left: 10px;">
        <label class="switch">
          <input type="checkbox" v-model="project.UF_IS_PRODACTION_SP_TERR" />
          <span class="slider round"></span>
        </label>
      </span>
    </div>
    <SpecialPlace v-if="project.UF_IS_PRODACTION_SP_TERR"></SpecialPlace>

    <HelpFiledStep2
      v-if="project.UF_SETTING.IS_VIEW_HIGH_TECH == 1"
      text="18. Ключевые исполнители (поставщик продукции, услуг, на которого
      приходится не менее 20% от суммы займа)"
      :helpText="this.project.UF_HELP.FIELDS.STEP2['BLOCK_COAUTHOR']"
    />
    <HelpFiledStep2
      v-else
      text="17. Ключевые исполнители (поставщик продукции, услуг, на которого
      приходится не менее 20% от суммы займа)"
      :helpText="this.project.UF_HELP.FIELDS.STEP2['BLOCK_COAUTHOR']"
    />
    <subcontractors />

    <div class="content-title content-mb-14">
      <span v-if="project.UF_SETTING.AUTO_NAMEP10_IS_LASTNAME"
      >18. Комплектующее изделие (в соотв. с ПП РФ от 17.07.2015 №719)</span
      >
      <span v-else
      > <span v-if="project.UF_SETTING.IS_VIEW_HIGH_TECH == 1">19</span><span v-else>18</span>. Транспортные средства или их комплектующие изделия (в соотв. с ПП
        РФ от 17.07.2015 №719)</span
      >
      <!--   начало блока подсказки   -->
      <span
        v-if="
          project.UF_HELP &&
            project.UF_HELP.FIELDS &&
            project.UF_HELP.FIELDS.STEP2 &&
            project.UF_HELP.FIELDS.STEP2.UF_VID_PRODUCTION_ID
        "
        class="h-t-status-info info-holder-container"
      >
        <span class="info-holder-icon"></span>
        <span class="info-holder-content info-holder-content_link">
          <span class="info-holder-content__text">
            {{ project.UF_HELP.FIELDS.STEP2.UF_VID_PRODUCTION_ID }}
          </span>
        </span>
      </span>
      <!--   конец блока подсказки   -->
    </div>
    <PromProducts></PromProducts>
    <Uf_product_req_719></Uf_product_req_719>

    <div class="content-title content-mb-14">
      <span v-if="project.UF_SETTING.IS_VIEW_HIGH_TECH == 1">20</span
      ><span v-else>19</span>. Включение продукции проекта в отраслевые планы импортозамещения
      <template
        v-if="
          project.UF_SETTING.SHOW_IMPORT_PLAN_ID &&
            project.UF_SETTING.SHOW_IMPORT_PLAN_ID.length > 0
        "
      >/ Перечни критической продукции
      </template
      >
    </div>
    <import_plan>tree_group_med_oborudovanie</import_plan>

    <template v-if="project.UF_SETTING.IS_HIDE_NDT !== 1">
      <HelpFiledStep2
        text="20. Соответствуют ли технологии, применяемые в рамках проекта, правилам
      НДТ"
        :helpText="this.project.UF_HELP.FIELDS.STEP2['UF_IS_NDT']"
      />
      <uf_is_ndt />
    </template>

    <template
      v-if="project.UF_SETTING.IS_VIEW_REESTR_USING_RM == 1"
    >
      <div class="content-title content-title-2line content-mb-14">
        <span v-if="project.UF_SETTING.IS_VIEW_HIGH_TECH == 1">21</span><span v-else>20</span>. Компания включена в
        Реестр производителей товаров с использованием вторичного сырья?
      </div>
      <Uf_is_reestr_using_rm></Uf_is_reestr_using_rm>
    </template>

    <template v-if="project.UF_SETTING.IS_VIEW_OKPO_COMPANY == 1">
      <uf_okpo>
        <span v-if="project.UF_SETTING.IS_VIEW_REESTR_USING_RM == 1">22</span>
        <span v-else>21</span>.
      </uf_okpo>
    </template>
    <template v-if="project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS == 1">
      <div class="content-title content-mb-14">
        <span v-if="project.UF_SETTING.IS_VIEW_REESTR_USING_RM == 1">{{ 22 + okpoShift }}</span>
        <span v-else>{{ 21 + okpoShift }}</span>. Финансовые показатели организации
      </div>
      <financialIndicator></financialIndicator>
    </template>

    <HelpFiledStep2
      v-if="project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS == 1 && project.UF_SETTING.IS_VIEW_REESTR_USING_RM == 1"
      :text="`${23 + okpoShift}. Сумма фактически выплаченных дивидендов`"
      :helpText="this.project.UF_HELP.FIELDS.STEP2['DIVIDENDS']"
    />
    <HelpFiledStep2
      v-else
      :text="`${22 + okpoShift}. Сумма фактически выплаченных дивидендов`"
      :helpText="this.project.UF_HELP.FIELDS.STEP2['DIVIDENDS']"
    />
    <dividendsIndicator :isMainPunct="true"></dividendsIndicator>

    <div v-if="project.UF_INDICATOR_VERSION === 1">
      <div class="content-title content-mb-14">
        21. Сбыт продукции проекта, обеспечивающий выход на целевой объем продаж
      </div>
      <export_countries></export_countries>

      <div
        class="row myrow content-mb-42"
        v-if="project.UF_INDICATOR_VERSION === 1"
      >
        <div class="col-xs-12 mycol">
          <textarea
            :disabled="$parent.projectDisabled"
            v-model="project.UF_SALE"
            class="i-main-style t-dop-style i-wid-50"
            placeholder="Укажите планируемые объемы продаж/спроса, наличие инструментов реализации продукции проекта, перечень договоренностей по реализации продукции проекта: соглашения, предварительные соглашения, переговоры и т.п."
          ></textarea>
        </div>
      </div>
    </div>

  </div>
  <!--container-fluid-->
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_DIRECTORIES, FETCH_DIRECTORY } from "@/store/actions.type";
import VueTagsInput from "@johmun/vue-tags-input";
import { AUTH_URL } from "@/common/config";
import Vue from "vue";
import SystemIntegrator from "@/components/project/form/partial/SystemIntegrator";
import Digital_solution from "@/components/project/form/partial/DigitalSolution";
import System_equipment from "@/components/project/form/partial/SystemEquipment";
import Uf_name from "@/components/project/form/partial/uf_name";
import Uf_support_prog_id from "@/components/project/form/partial/uf_support_prog_id";
import Uf_sum_request from "@/components/project/form/partial/uf_sum_request";
import Uf_month_return from "@/components/project/form/partial/uf_month_return";
import Uf_industry_id from "@/components/project/form/partial/uf_industry_id";
import Uf_sub_industry_id from "@/components/project/form/partial/uf_sub_industry_id";
import Okpd from "@/components/project/form/partial/okpd";
import ProjectOkpdProducts from "@/components/project/form/partial/ProjectOkpdProducts";
import Uf_annotation from "@/components/project/form/partial/uf_annotation";
import Uf_available_results from "@/components/project/form/partial/uf_available_results";
import Place from "@/components/project/form/partial/place";
import Subcontractors from "@/components/project/form/partial/subcontractors";
import PlanBuyersProducts from "@/components/project/form/partial/plan_buyers_products";
import Import_plan from "@/components/project/form/partial/import_plan";
import Uf_result_natural from "@/components/project/form/partial/uf_result_natural";
import Target_years from "@/components/project/form/partial/target_years";
import Export_countries from "@/components/project/form/partial/export_countries";
import Uf_is_reg_fond_help from "@/components/project/form/partial/uf_is_reg_fond_help";
import Uf_product_req_719 from "@/components/project/form/partial/uf_product_req_719";
import Uf_component_pp_719 from "@/components/project/form/partial/uf_component_pp_719";
import Uf_prioriti_complect_auto from "@/components/project/form/partial/uf_prioriti_complect_auto";
import Uf_is_ndt from "@/components/project/form/partial/uf_is_ndt";
import PromProducts from "@/components/project/form/partial/PromProducts";
import HighTechList from "@/components/project/form/partial/HighTechList";
import SpecialPlace from "@/components/project/form/partial/SpecialPlace";
import financialIndicator from "@/components/project/form/partial/FinancialIndicator";
import { Dropdown as VDropdown } from "floating-vue";
import HelpFiledStep2 from "@/components/project/form/subpartial/HelpFiledStep2.vue";
import Uf_okpo from "@/components/project/form/partial/uf_okpo";
import uf_is_prevails_mutual_invest_fund from "@/components/project/form/partial/uf_is_prevails_mutual_invest_fund";
import HighTechProducts from "@/components/project/form/partial/HighTechProducts.vue";
import Uf_is_reestr_using_rm from "@/components/project/form/partial/uf_is_reestr_using_rm.vue";
import dividendsIndicator from "@/components/project/form/partial/DividendsIndicator.vue";

export default {
  name: "step2",
  props: ["step", "project"],
  components: {
    Uf_okpo,
    Uf_is_reestr_using_rm,
    HighTechProducts,
    SpecialPlace,
    HighTechList,
    PromProducts,
    Uf_is_reg_fond_help,
    Export_countries,
    Target_years,
    Uf_result_natural,
    Import_plan,
    Subcontractors,
    PlanBuyersProducts,
    Place,
    Uf_available_results,
    Uf_annotation,
    Okpd,
    ProjectOkpdProducts,
    Uf_sub_industry_id,
    Uf_industry_id,
    Uf_month_return,
    Uf_sum_request,
    Uf_support_prog_id,
    Uf_name,
    Uf_is_ndt,
    System_equipment,
    Digital_solution,
    SystemIntegrator,
    Uf_product_req_719,
    Uf_component_pp_719,
    financialIndicator,
    Uf_prioriti_complect_auto,
    VueTagsInput,
    VDropdown,
    HelpFiledStep2,
    uf_is_prevails_mutual_invest_fund,
    dividendsIndicator
  },
  data() {
    return {
      selectedTags: [],
      h4tooltip:
        "Успешная реализация Вашего проекта важна для региона. Если Вы хотите предоставить Региональному фонду доступ к текущей заявке, получить консультационную поддержку и помощь, выберите «Да» в выпадающем списке:",
      hCoExecutorTooltip:
        "Заполнение данного поля позволит Вам ускорить процедуру проведения акцептов платежей после получения средств займа.",
      h14tooltipShow: false,
      h14tooltip:
        "<img src='https://lkbe.frprf.ru/images/project/p13_info.png' />",
      siteUrl: "",
      tag: "",
      tags: [],
      RESULT_INTELLECTUAL_ACTIVITY: false,
      h18tooltip:
        "Ставка по предоставляемому целевому займу может быть изменена Фондом на 1% годовых,  если  выполнено требование п.7.3 Стандарта \"Цифровизация промышленности\"",
      h15tooltip:
        "Для возможного применения ставки 1 (один) процент годовых к займам, финансируемым по\n" +
        "                                программе «Цифровизация промышленности», Системный интегратор цифровых и\n" +
        "                                технологических\n" +
        "                                решений (далее - Системный интегратор), привлеченный в качестве Ключевого\n" +
        "                                исполнителя\n" +
        "                                (Одобренный ФРП при принятии решения о предоставлении займа) по проекту, должен\n" +
        "                                соответствовать следующим критериям:<br/>\n" +
        "                                1. являться резидентом РФ (определяется в соответствии с законодательством о валютном регулировании и валютном контроле);<br/>\n" +
        "                                2. не являться дочерним хозяйственным обществом (определяется в соответствии с ч. 1 ст. 67.3 ГК РФ) юридических лиц, созданных в соответствии с законодательством иностранных государств;<br/>\n" +
        "                                3. не находиться  процессе ликвидации или банкротства;<br/>\n" +
        "                                4. выплаты Заемщика по договорам/контрактам, заключенным с Системным интегратором в ходе реализации проекта составляют более 50% от суммы займа;<br/>\n" +
        "                                5. должен быть включен в один из рейтингов (применению подлежит актуальный рейтинг на последнюю отчетную дату и учитывается включение ключевого исполнителя в последнюю версию рейтинга российских ИТ-компаний), публикующихся на следующих информационных ресурсах:<br/>\n" +
        "                                • Раздел \"ИТ-консалтинг (разработка и системная интеграция)\" рэнкинга \"Список крупнейших российских консалтинговых групп и компаний\" Эксперт-РА (https://raex-a.ru/);<br/>\n" +
        "                                • Крупнейшие ИТ-компании России Cnews (www.cnews.ru);<br/>\n" +
        "                                • Крупнейшие ИТ-компании России Tadviser (www.tadviser.ru)."
    };
  },
  created() {
    this.siteUrl = AUTH_URL;
    this.$store.dispatch(FETCH_DIRECTORIES, [
      "program_fin_support",
      "tree/industry",
      "code_okpd",
      "regions",
      "sp_monogorod",
      "list_import_plan",
      "product_plan_import",
      "start_pokazatel",
      "tree/vid_prom_products",
      "high_tehnology_sp",
      "sp_ndt",
      "sp_priority_components_auto",
      "tree/sp_orders_high_tech_industry"
    ]);

    if (this.project.SUBCONTRACTORS.length === 0) {
      //this.project.SUBCONTRACTORS.push({});
    }

    if (this.project.INDICATORS.items.length === 0) {
      this.project.INDICATORS.items = new Object();
    }
    let m = this;
    this.project.INDICATORS.INDICATORS_ID.forEach(function(indicator) {
      if (typeof m.project.INDICATORS.items[indicator] === "undefined") {
        Vue.set(m.project.INDICATORS.items, indicator, []);
      }
      for (
        let year = m.project.INDICATORS.yearStart;
        year <= m.project.INDICATORS.yearEnd;
        year++
      ) {
        let t = m.project.INDICATORS.items[indicator].filter(
          c => c.UF_INDICATORS_YEAR === year
        );
        if (t.length === 0) {
          m.project.INDICATORS.items[indicator].push({
            UF_INDICATORS_VALUE: 0,
            UF_INDICATORS_YEAR: year,
            UF_INDICATORS_ID: indicator
          });
        }
      }
    });

    this.$store
      .dispatch(FETCH_DIRECTORY, ["tree/sp_infoproduction"])
      .then(() => {
      }, this);
  },
  methods: {
    getInfoproductionId(code) {
      let t = this.directory.tree_sp_infoproduction.filter(
        c => c.CODE === code
      );
      if (t.length > 0 && t[0].URL !== null) {
        return t[0].ID;
      }
      return "";
    },
    programCode(id) {
      let els = this.directory.program_fin_support.filter(function(el) {
        if (el.ID === id) {
          return true;
        }
        return false;
      }, this);
      if (els.length > 0) {
        return els[0].CODE;
      }
      return "";
    }
  },
  computed: {
    okpoShift() {
      return this.project.UF_SETTING &&
        this.project.UF_SETTING.IS_VIEW_OKPO_COMPANY == 1
        ? 1
        : 0;
    },
    ...mapGetters(["directory"])
  }
};
</script>

<style scoped></style>
